import { z } from 'zod';
// Common validation helpers
/**
 * Numeric string that transforms to number
 */
export const numericString = z
    .string()
    .regex(/^\d+$/, 'Must be a number')
    .transform((v) => parseInt(v, 10));
/**
 * Optional numeric string with default
 */
export const optionalNumericString = (defaultValue) => z
    .string()
    .regex(/^\d+$/, 'Must be a number')
    .optional()
    .default(String(defaultValue))
    .transform((v) => parseInt(v, 10));
/**
 * Pagination parameters
 */
export const paginationSchema = z.object({
    page: optionalNumericString(0).refine((v) => v >= 0, 'Page must be >= 0'),
    page_size: optionalNumericString(50).refine((v) => v > 0 && v <= 1000, 'Page size must be 1-1000'),
});
/**
 * Sort parameters
 */
export const sortSchema = z.object({
    order_by: z.string().optional(),
    order_type: z.enum(['asc', 'desc']).optional().default('desc'),
});
/**
 * ID parameter (for route params)
 */
export const idParamSchema = z.object({
    id: numericString,
});
/**
 * String ID parameter (for UUIDs)
 */
export const stringIdParamSchema = z.object({
    id: z.string().min(1),
});
